import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlTypographyComponent } from '../sl-typography/sl-typography.component';
import { SlLinkComponent } from '../sl-link/sl-link.component';

@Component({
  selector: 'sl-snackbar',
  standalone: true,
  imports: [CommonModule, SlTypographyComponent, SlLinkComponent],
  templateUrl: './sl-snackbar.component.html',
  styleUrl: './sl-snackbar.component.scss',
})
export class SlSnackbarComponent {
  @Input() text!: string;
  @Input() actionText!: string;
  @Output() actionEvent: EventEmitter<void> = new EventEmitter<void>();

  clickLinkEvent() {
    this.actionEvent.emit();
  }
}
